import React, { createContext, useContext, useState, useEffect } from 'react';
import { getUserCurrency } from '../utils/geoLocation';

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
    const [selectedCurrency, setSelectedCurrency] = useState('USD');
    const [customPrices, setCustomPrices] = useState({
        "USD": {
            "starter": 300,
            "pro": 500,
            "business": 700,
            "enterprise": 1000,
            "hosting1Month": 15,
            "hosting3Month": 12,
            "hosting6Month": 10,
            "hosting12Month": 5
        },
        "JPY": {
            "starter": 29800,
            "pro": 59800,
            "business": 8900,
            "enterprise": 149800,
            "hosting1Month": 2200,
            "hosting3Month": 1800,
            "hosting6Month": 1400,
            "hosting12Month": 900
        },
        "GBP": {
            "starter": 149,
            "pro": 299,
            "business": 449,
            "enterprise": 749,
            "hosting1Month": 11,
            "hosting3Month": 9,
            "hosting6Month": 7,
            "hosting12Month": 5
        },
        "CHF": {
            "starter": 169,
            "pro": 329,
            "business": 489,
            "enterprise": 809,
            "hosting1Month": 12,
            "hosting3Month": 10,
            "hosting6Month": 8,
            "hosting12Month": 5
        },
        "CAD": {
            "starter": 279,
            "pro": 559,
            "business": 829,
            "enterprise": 1399,
            "hosting1Month": 21,
            "hosting3Month": 17,
            "hosting6Month": 13,
            "hosting12Month": 9
        },
        " AUD": {
            "starter": 309,
            "pro": 619,
            "business": 929,
            "enterprise": 1549,
            "hosting1Month": 23,
            "hosting3Month": 19,
            "hosting6Month": 15,
            "hosting12Month": 9
        },
        "NZD": {
            "starter": 339,
            "pro": 679,
            "business": 1019,
            "enterprise": 1699,
            "hosting1Month": 25,
            "hosting3Month": 21,
            "hosting6Month": 15,
            "hosting12Month": 11
        },
        "CNY": {
            "starter": 1499,
            "pro": 2899,
            "business": 4399,
            "enterprise": 7199,
            "hosting1Month": 109,
            "hosting3Month": 89,
            "hosting6Month": 69,
            "hosting12Month": 45
        },
        "HKD": {
            "starter": 1599,
            "pro": 3199,
            "business": 4699,
            "enterprise": 7899,
            "hosting1Month": 119,
            "hosting3Month": 95,
            "hosting6Month": 75,
            "hosting12Month": 49
        },
        "SGD": {
            "starter": 259,
            "pro": 519,
            "business": 779,
            "enterprise": 1299,
            "hosting1Month": 19,
            "hosting3Month": 15,
            "hosting6Month": 12,
            "hosting12Month": 9
        },
        "KRW": {
            "starter": 279000,
            "pro": 559000,
            "business": 839000,
            "enterprise": 1399000,
            "hosting1Month": 20900,
            "hosting3Month": 16900,
            "hosting6Month": 12900,
            "hosting12Month": 8900
        },
        "SEK": {
            "starter": 1999,
            "pro": 3899,
            "business": 5799,
            "enterprise": 9599,
            "hosting1Month": 149,
            "hosting3Month": 119,
            "hosting6Month": 89,
            "hosting12Month": 59
        },
        "NOK": {
            "starter": 2099,
            "pro": 4099,
            "business": 6199,
            "enterprise": 10199,
            "hosting1Month": 159,
            "hosting3Month": 125,
            "hosting6Month": 95,
            "hosting12Month": 65
        },
        "DKK": {
            "starter": 1299,
            "pro": 2599,
            "business": 3899,
            "enterprise": 6399,
            "hosting1Month": 99,
            "hosting3Month": 79,
            "hosting6Month": 59,
            "hosting12Month": 39
        },

        "INR": {
            "starter": 4,
            "pro": 5,
            "business": 6,
            "enterprise": 7,
            "hosting1Month": 1,
            "hosting3Month": 2,
            "hosting6Month": 3,
            "hosting12Month": 4
        },
        "RUB": {
            "starter": 15999,
            "pro": 32099,
            "business": 48999,
            "enterprise": 80999,
            "hosting1Month": 1209,
            "hosting3Month": 969,
            "hosting6Month": 729,
            "hosting12Month": 489
        },
        "BRL": {
            "starter": 1099,
            "pro": 299,
            "business": 3299,
            "enterprise": 5499,
            "hosting1Month": 82,
            "hosting3Month": 69,
            "hosting6Month": 49,
            "hosting12Month": 33
        },
        "ZAR": {
            "starter": 3599,
            "pro": 7099,
            "business": 10599,
            "enterprise": 17999,
            "hosting1Month": 269,
            "hosting3Month": 219,
            "hosting6Month": 159,
            "hosting12Month": 109
        },
        "MXN": {
            "starter": 3799,
            "pro": 7499,
            "business": 11299,
            "enterprise": 18799,
            "hosting1Month": 289,
            "hosting3Month": 229,
            "hosting6Month": 169,
            "hosting12Month": 115
        },
        "TRY": {
            "starter": 8199,
            "pro": 16399,
            "business": 24999,
            "enterprise": 40999,
            "hosting1Month": 619,
            "hosting3Month": 499,
            "hosting6Month": 369,
            "hosting12Month": 249
        },
        "THB": {
            "starter": 6499,
            "pro": 12999,
            "business": 19499,
            "enterprise": 32999,
            "hosting1Month": 489,
            "hosting3Month": 399,
            "hosting6Month": 299,
            "hosting12Month": 199
        },
        "IDR": {
            "starter": 3229000,
            "pro": 6499000,
            "business": 9799000,
            "enterprise": 16199000,
            "hosting1Month": 243999,
            "hosting3Month": 194999,
            "hosting6Month": 145999,
            "hosting12Month": 97999
        },
        "MYR": {
            "starter": 849,
            "pro": 1699,
            "business": 2599,
            "enterprise": 4299,
            "hosting1Month": 65,
            "hosting3Month": 55,
            "hosting6Month": 39,
            "hosting12Month": 25
        },
        "PHP": {
            "starter": 11399,
            "pro": 22799,
            "business": 34199,
            "enterprise": 56999,
            "hosting1Month": 859,
            "hosting3Month": 689,
            "hosting6Month": 519,
            "hosting12Month": 349
        },
        "PLN": {
            "starter": 729,
            "pro": 1459,
            "business": 2199,
            "enterprise": 3699,
            "hosting1Month": 55,
            "hosting3Month": 45,
            "hosting6Month": 35,
            "hosting12Month": 23
        },
        "CZK": {
            "starter": 4199,
            "pro": 8399,
            "business": 12599,
            "enterprise": 20999,
            "hosting1Month": 319,
            "hosting3Month": 259,
            "hosting6Month": 189,
            "hosting12Month": 129
        },
        "HUF": {
            "starter": 67999,
            "pro": 135999,
            "business": 203999,
            "enterprise": 339999,
            "hosting1Month": 5099,
            "hosting3Month": 4099,
            "hosting6Month": 3099,
            "hosting12Month": 2099
        },
        "ILS": {
            "starter": 679,
            "pro": 1349,
            "business": 2099,
            "enterprise": 3399,
            "hosting1Month": 55,
            "hosting3Month": 45,
            "hosting6Month": 35,
            "hosting12Month": 25
        },
        "AFN": {
            "starter": 20000,
            "pro": 33500,
            "business": 47000,
            "enterprise": 67000,
            "hosting1Month": 1000,
            "hosting3Month": 800,
            "hosting6Month": 600,
            "hosting12Month": 400
        },
        "ALL": {
            "starter": 25000,
            "pro": 41500,
            "business": 58000,
            "enterprise": 83000,
            "hosting1Month": 1250,
            "hosting3Month": 1000,
            "hosting6Month": 750,
            "hosting12Month": 500
        },
        "AMD": {
            "starter": 115000,
            "pro": 191000,
            "business": 268000,
            "enterprise": 383000,
            "hosting1Month": 5750,
            "hosting3Month": 4600,
            "hosting6Month": 3450,
            "hosting12Month": 2300
        },
        "ANG": {
            "starter": 535,
            "pro": 895,
            "business": 1250,
            "enterprise": 1790,
            "hosting1Month": 27,
            "hosting3Month": 21,
            "hosting6Month": 16,
            "hosting12Month": 11
        },
        "AOA": {
            "starter": 275000,
            "pro": 460000,
            "business": 645000,
            "enterprise": 920000,
            "hosting1Month": 13800,
            "hosting3Month": 11000,
            "hosting6Month": 8300,
            "hosting12Month": 5500
        },
        "ARS": {
            "starter": 440000,
            "pro": 730000,
            "business": 1020000,
            "enterprise": 1460000,
            "hosting1Month": 22000,
            "hosting3Month": 17500,
            "hosting6Month": 13000,
            "hosting12Month": 8800
        },
        "AUD": {
            "starter": 450,
            "pro": 800,
            "business": 1100,
            "enterprise": 1550,
            "hosting1Month": 24,
            "hosting3Month": 18,
            "hosting6Month": 14,
            "hosting12Month": 8
        },
        "AWG": {
            "starter": 535,
            "pro": 895,
            "business": 1250,
            "enterprise": 1790,
            "hosting1Month": 27,
            "hosting3Month": 21,
            "hosting6Month": 16,
            "hosting12Month": 11
        },
        "AZN": {
            "starter": 510,
            "pro": 850,
            "business": 1190,
            "enterprise": 1700,
            "hosting1Month": 26,
            "hosting3Month": 20,
            "hosting6Month": 15,
            "hosting12Month": 10
        },
        "BAM": {
            "starter": 500,
            "pro": 840,
            "business": 1175,
            "enterprise": 1680,
            "hosting1Month": 25,
            "hosting3Month": 20,
            "hosting6Month": 15,
            "hosting12Month": 10
        },
        "BBD": {
            "starter": 600,
            "pro": 1000,
            "business": 1400,
            "enterprise": 2000,
            "hosting1Month": 30,
            "hosting3Month": 24,
            "hosting6Month": 18,
            "hosting12Month": 12
        },
        "BDT": {
            "starter": 36500,
            "pro": 61000,
            "business": 85500,
            "enterprise": 122000,
            "hosting1Month": 1830,
            "hosting3Month": 1460,
            "hosting6Month": 1100,
            "hosting12Month": 730
        },
        "BGN": {
            "starter": 500,
            "pro": 840,
            "business": 1175,
            "enterprise": 1680,
            "hosting1Month": 25,
            "hosting3Month": 20,
            "hosting6Month": 15,
            "hosting12Month": 10
        },
        "BHD": {
            "starter": 112,
            "pro": 188,
            "business": 265,
            "enterprise": 375,
            "hosting1Month": 6,
            "hosting3Month": 5,
            "hosting6Month": 3,
            "hosting12Month": 2
        },
        "BIF": {
            "starter": 880000,
            "pro": 1470000,
            "business": 2060000,
            "enterprise": 2940000,
            "hosting1Month": 44000,
            "hosting3Month": 35000,
            "hosting6Month": 26500,
            "hosting12Month": 17700
        },
        "BMD": {
            "starter": 300,
            "pro": 500,
            "business": 700,
            "enterprise": 1000,
            "hosting1Month": 15,
            "hosting3Month": 12,
            "hosting6Month": 10,
            "hosting12Month": 5
        },
        "BND": {
            "starter": 385,
            "pro": 645,
            "business": 900,
            "enterprise": 1290,
            "hosting1Month": 19,
            "hosting3Month": 15,
            "hosting6Month": 12,
            "hosting12Month": 8
        },
        "BOB": {
            "starter": 2075,
            "pro": 3460,
            "business": 4845,
            "enterprise": 6925,
            "hosting1Month": 105,
            "hosting3Month": 83,
            "hosting6Month": 62,
            "hosting12Month": 42
        },
        "BRL": {
            "starter": 1600,
            "pro": 2700,
            "business": 3800,
            "enterprise": 5400,
            "hosting1Month": 80,
            "hosting3Month": 65,
            "hosting6Month": 50,
            "hosting12Month": 32
        },
        "BSD": {
            "starter": 300,
            "pro": 500,
            "business": 700,
            "enterprise": 1000,
            "hosting1Month": 15,
            "hosting3Month": 12,
            "hosting6Month": 10,
            "hosting12Month": 5
        },
        "BTN": {
            "starter": 26300,
            "pro": 43900,
            "business": 61500,
            "enterprise": 87900,
            "hosting1Month": 1320,
            "hosting3Month": 1055,
            "hosting6Month": 790,
            "hosting12Month": 530
        },
        "BWP": {
            "starter": 4100,
            "pro": 6900,
            "business": 9650,
            "enterprise": 13800,
            "hosting1Month": 205,
            "hosting3Month": 165,
            "hosting6Month": 125,
            "hosting12Month": 82
        },
        "BYN": {
            "starter": 965,
            "pro": 1610,
            "business": 2260,
            "enterprise": 3230,
            "hosting1Month": 48,
            "hosting3Month": 39,
            "hosting6Month": 29,
            "hosting12Month": 19
        },
        "BZD": {
            "starter": 600,
            "pro": 1000,
            "business": 1400,
            "enterprise": 2000,
            "hosting1Month": 30,
            "hosting3Month": 24,
            "hosting6Month": 18,
            "hosting12Month": 12
        },
        "CAD": {
            "starter": 420,
            "pro": 700,
            "business": 980,
            "enterprise": 1400,
            "hosting1Month": 21,
            "hosting3Month": 17,
            "hosting6Month": 13,
            "hosting12Month": 8
        },
        "CDF": {
            "starter": 660000,
            "pro": 1100000,
            "business": 1540000,
            "enterprise": 2200000,
            "hosting1Month": 33000,
            "hosting3Month": 26500,
            "hosting6Month": 19850,
            "hosting12Month": 13200
        },
        "CHF": {
            "starter": 235,
            "pro": 395,
            "business": 555,
            "enterprise": 790,
            "hosting1Month": 12,
            "hosting3Month": 10,
            "hosting6Month": 7,
            "hosting12Month": 5
        },
        "CLP": {
            "starter": 285000,
            "pro": 475000,
            "business": 670000,
            "enterprise": 955000,
            "hosting1Month": 14300,
            "hosting3Month": 11500,
            "hosting6Month": 8600,
            "hosting12Month": 5750
        },
        "CNY": {
            "starter": 2100,
            "pro": 3550,
            "business": 4950,
            "enterprise": 7100,
            "hosting1Month": 105,
            "hosting3Month": 85,
            "hosting6Month": 65,
            "hosting12Month": 42
        },
        "COP": {
            "starter": 1150000,
            "pro": 1910000,
            "business": 2680000,
            "enterprise": 3830000,
            "hosting1Month": 57500,
            "hosting3Month": 46000,
            "hosting6Month": 34500,
            "hosting12Month": 23000
        },
        "CRC": {
            "starter": 150000,
            "pro": 250000,
            "business": 350000,
            "enterprise": 500000,
            "hosting1Month": 7500,
            "hosting3Month": 6000,
            "hosting6Month": 4500,
            "hosting12Month": 3000
        },
        "CUP": {
            "starter": 7200,
            "pro": 12000,
            "business": 16800,
            "enterprise": 24000,
            "hosting1Month": 360,
            "hosting3Month": 290,
            "hosting6Month": 215,
            "hosting12Month": 145
        },
        "CVE": {
            "starter": 28300,
            "pro": 47200,
            "business": 66200,
            "enterprise": 94600,
            "hosting1Month": 1420,
            "hosting3Month": 1135,
            "hosting6Month": 850,
            "hosting12Month": 570
        },
        "CZK": {
            "starter": 6250,
            "pro": 10400,
            "business": 14500,
            "enterprise": 20800,
            "hosting1Month": 315,
            "hosting3Month": 250,
            "hosting6Month": 190,
            "hosting12Month": 125
        },
        "DJF": {
            "starter": 53000,
            "pro": 88500,
            "business": 124000,
            "enterprise": 177500,
            "hosting1Month": 2650,
            "hosting3Month": 2100,
            "hosting6Month": 1600,
            "hosting12Month": 1050
        },
        "DKK": {
            "starter": 1900,
            "pro": 3200,
            "business": 4500,
            "enterprise": 6400,
            "hosting1Month": 95,
            "hosting3Month": 75,
            "hosting6Month": 60,
            "hosting12Month": 40
        },
        "DOP": {
            "starter": 19000,
            "pro": 31600,
            "business": 44300,
            "enterprise": 63300,
            "hosting1Month": 950,
            "hosting3Month": 760,
            "hosting6Month": 570,
            "hosting12Month": 380
        },
        "DZD": {
            "starter": 38800,
            "pro": 64700,
            "business": 90600,
            "enterprise": 129500,
            "hosting1Month": 1950,
            "hosting3Month": 1555,
            "hosting6Month": 1170,
            "hosting12Month": 780
        },
        "EGP": {
            "starter": 14200,
            "pro": 23700,
            "business": 33200,
            "enterprise": 47500,
            "hosting1Month": 710,
            "hosting3Month": 570,
            "hosting6Month": 430,
            "hosting12Month": 285
        },
        "ERN": {
            "starter": 4500,
            "pro": 7500,
            "business": 10500,
            "enterprise": 15000,
            "hosting1Month": 225,
            "hosting3Month": 180,
            "hosting6Month": 135,
            "hosting12Month": 90
        },
        "ETB": {
            "starter": 44000,
            "pro": 73500,
            "business": 103000,
            "enterprise": 147500,
            "hosting1Month": 2200,
            "hosting3Month": 1750,
            "hosting6Month": 1300,
            "hosting12Month": 885
        },
        "EUR": {
            "starter": 250,
            "pro": 425,
            "business": 600,
            "enterprise": 900,
            "hosting1Month": 12,
            "hosting3Month": 10,
            "hosting6Month": 8,
            "hosting12Month": 6
        },
        "FJD": {
            "starter": 680,
            "pro": 1140,
            "business": 1600,
            "enterprise": 2280,
            "hosting1Month": 34,
            "hosting3Month": 27,
            "hosting6Month": 21,
            "hosting12Month": 14
        },
        "FKP": {
            "starter": 225,
            "pro": 370,
            "business": 520,
            "enterprise": 745,
            "hosting1Month": 11,
            "hosting3Month": 9,
            "hosting6Month": 7,
            "hosting12Month": 4
        },
        "GBP": {
            "starter": 225,
            "pro": 370,
            "business": 520,
            "enterprise": 745,
            "hosting1Month": 11,
            "hosting3Month": 9,
            "hosting6Month": 7,
            "hosting12Month": 4
        },
        "GEL": {
            "starter": 810,
            "pro": 1350,
            "business": 1890,
            "enterprise": 2700,
            "hosting1Month": 40,
            "hosting3Month": 32,
            "hosting6Month": 24,
            "hosting12Month": 16
        },
        "GHS": {
            "starter": 3200,
            "pro": 5350,
            "business": 7500,
            "enterprise": 10750,
            "hosting1Month": 160,
            "hosting3Month": 130,
            "hosting6Month": 95,
            "hosting12Month": 65
        },
        "GIP": {
            "starter": 225,
            "pro": 370,
            "business": 520,
            "enterprise": 745,
            "hosting1Month": 11,
            "hosting3Month": 9,
            "hosting6Month": 7,
            "hosting12Month": 4
        },
        "GMD": {
            "starter": 22000,
            "pro": 36500,
            "business": 51000,
            "enterprise": 73000,
            "hosting1Month": 1100,
            "hosting3Month": 880,
            "hosting6Month": 660,
            "hosting12Month": 440
        },
        "GNF": {
            "starter": 2600000,
            "pro": 4340000,
            "business": 6080000,
            "enterprise": 8690000,
            "hosting1Month": 130000,
            "hosting3Month": 104000,
            "hosting6Month": 78000,
            "hosting12Month": 52000
        },
        "GTQ": {
            "starter": 2300,
            "pro": 3825,
            "business": 5350,
            "enterprise": 7650,
            "hosting1Month": 115,
            "hosting3Month": 92,
            "hosting6Month": 69,
            "hosting12Month": 46
        },
        "GYD": {
            "starter": 62500,
            "pro": 104000,
            "business": 146000,
            "enterprise": 209000,
            "hosting1Month": 3100,
            "hosting3Month": 2500,
            "hosting6Month": 1900,
            "hosting12Month": 1250
        },
        "HKD": {
            "starter": 2300,
            "pro": 3850,
            "business": 5400,
            "enterprise": 7750,
            "hosting1Month": 115,
            "hosting3Month": 92,
            "hosting6Month": 70,
            "hosting12Month": 47
        },
        "HNL": {
            "starter": 7850,
            "pro": 13100,
            "business": 18350,
            "enterprise": 26200,
            "hosting1Month": 395,
            "hosting3Month": 315,
            "hosting6Month": 235,
            "hosting12Month": 155
        },
        "HTG": {
            "starter": 39000,
            "pro": 65000,
            "business": 91500,
            "enterprise": 131000,
            "hosting1Month": 1950,
            "hosting3Month": 1550,
            "hosting6Month": 1150,
            "hosting12Month": 785
        },
        "HUF": {
            "starter": 100000,
            "pro": 165000,
            "business": 233000,
            "enterprise": 333000,
            "hosting1Month": 5000,
            "hosting3Month": 4000,
            "hosting6Month": 3000,
            "hosting12Month": 2000
        },
        "IDR": {
            "starter": 4950000,
            "pro": 8250000,
            "business": 11550000,
            "enterprise": 16500000,
            "hosting1Month": 248000,
            "hosting3Month": 198000,
            "hosting6Month": 149000,
            "hosting12Month": 99000
        },
        "ILS": {
            "starter": 1000,
            "pro": 1700,
            "business": 2300,
            "enterprise": 3300,
            "hosting1Month": 49,
            "hosting3Month": 39,
            "hosting6Month": 29,
            "hosting12Month": 19
        },
        "INR": {
            "starter": 25000,
            "pro": 45000,
            "business": 60000,
            "enterprise": 85000,
            "hosting1Month": 1199,
            "hosting3Month": 999,
            "hosting6Month": 799,
            "hosting12Month": 499
        },
        "IQD": {
            "starter": 390000,
            "pro": 650000,
            "business": 915000,
            "enterprise": 1310000,
            "hosting1Month": 19500,
            "hosting3Month": 15500,
            "hosting6Month": 11500,
            "hosting12Month": 7850
        },
        "IRR": {
            "starter": 12700000,
            "pro": 21200000,
            "business": 29700000,
            "enterprise": 42400000,
            "hosting1Month": 635000,
            "hosting3Month": 508000,
            "hosting6Month": 381000,
            "hosting12Month": 254000
        },
        "ISK": {
            "starter": 36000,
            "pro": 60500,
            "business": 85000,
            "enterprise": 121000,
            "hosting1Month": 1800,
            "hosting3Month": 1450,
            "hosting6Month": 1100,
            "hosting12Month": 725
        },
        "JMD": {
            "starter": 48000,
            "pro": 80000,
            "business": 112500,
            "enterprise": 161000,
            "hosting1Month": 2400,
            "hosting3Month": 1900,
            "hosting6Month": 1450,
            "hosting12Month": 965
        },
        "JOD": {
            "starter": 210,
            "pro": 355,
            "business": 495,
            "enterprise": 705,
            "hosting1Month": 11,
            "hosting3Month": 9,
            "hosting6Month": 6,
            "hosting12Month": 4
        },
        "JPY": {
            "starter": 45000,
            "pro": 75000,
            "business": 105000,
            "enterprise": 150000,
            "hosting1Month": 2250,
            "hosting3Month": 1800,
            "hosting6Month": 1350,
            "hosting12Month": 900
        },
        "KES": {
            "starter": 38500,
            "pro": 64500,
            "business": 90000,
            "enterprise": 129000,
            "hosting1Month": 1900,
            "hosting3Month": 1500,
            "hosting6Month": 1150,
            "hosting12Month": 775
        },
        "KGS": {
            "starter": 26000,
            "pro": 43500,
            "business": 61000,
            "enterprise": 87000,
            "hosting1Month": 1300,
            "hosting3Month": 1050,
            "hosting6Month": 785,
            "hosting12Month": 525
        },
        "KHR": {
            "starter": 1200000,
            "pro": 2000000,
            "business": 2800000,
            "enterprise": 4010000,
            "hosting1Month": 60000,
            "hosting3Month": 48000,
            "hosting6Month": 36000,
            "hosting12Month": 24000
        },
        "KMF": {
            "starter": 126000,
            "pro": 210000,
            "business": 295000,
            "enterprise": 422000,
            "hosting1Month": 6300,
            "hosting3Month": 5050,
            "hosting6Month": 3800,
            "hosting12Month": 2530
        },
        "KRW": {
            "starter": 425000,
            "pro": 709000,
            "business": 993000,
            "enterprise": 1420000,
            "hosting1Month": 21300,
            "hosting3Month": 17000,
            "hosting6Month": 12800,
            "hosting12Month": 8500
        },
        "KWD": {
            "starter": 92,
            "pro": 153,
            "business": 215,
            "enterprise": 305,
            "hosting1Month": 5,
            "hosting3Month": 4,
            "hosting6Month": 3,
            "hosting12Month": 2
        },
        "KYD": {
            "starter": 250,
            "pro": 415,
            "business": 580,
            "enterprise": 830,
            "hosting1Month": 12,
            "hosting3Month": 10,
            "hosting6Month": 7,
            "hosting12Month": 5
        },
        "KZT": {
            "starter": 161000,
            "pro": 269000,
            "business": 376000,
            "enterprise": 538000,
            "hosting1Month": 8100,
            "hosting3Month": 6450,
            "hosting6Month": 4850,
            "hosting12Month": 3230
        },
        "LAK": {
            "starter": 6500000,
            "pro": 10850000,
            "business": 15200000,
            "enterprise": 21700000,
            "hosting1Month": 325000,
            "hosting3Month": 260000,
            "hosting6Month": 195000,
            "hosting12Month": 130000
        },
        "LBP": {
            "starter": 26700000,
            "pro": 44600000,
            "business": 62500000,
            "enterprise": 89400000,
            "hosting1Month": 1340000,
            "hosting3Month": 1070000,
            "hosting6Month": 805000,
            "hosting12Month": 537000
        },
        "LKR": {
            "starter": 90500,
            "pro": 151000,
            "business": 211500,
            "enterprise": 302000,
            "hosting1Month": 4550,
            "hosting3Month": 3630,
            "hosting6Month": 2720,
            "hosting12Month": 1815
        },
        "LRD": {
            "starter": 55000,
            "pro": 91500,
            "business": 128000,
            "enterprise": 183000,
            "hosting1Month": 2750,
            "hosting3Month": 2200,
            "hosting6Month": 1650,
            "hosting12Month": 1100
        },
        "LSL": {
            "starter": 5150,
            "pro": 8600,
            "business": 12050,
            "enterprise": 17200,
            "hosting1Month": 260,
            "hosting3Month": 205,
            "hosting6Month": 155,
            "hosting12Month": 105
        },
        "LYD": {
            "starter": 1625,
            "pro": 2710,
            "business": 3800,
            "enterprise": 5425,
            "hosting1Month": 80,
            "hosting3Month": 65,
            "hosting6Month": 50,
            "hosting12Month": 33
        },
        "MAD": {
            "starter": 2750,
            "pro": 4600,
            "business": 6450,
            "enterprise": 9200,
            "hosting1Month": 140,
            "hosting3Month": 110,
            "hosting6Month": 85,
            "hosting12Month": 55
        },
        "MDL": {
            "starter": 5050,
            "pro": 8400,
            "business": 11800,
            "enterprise": 16850,
            "hosting1Month": 255,
            "hosting3Month": 200,
            "hosting6Month": 150,
            "hosting12Month": 100
        },
        "MGA": {
            "starter": 1350000,
            "pro": 2250000,
            "business": 3150000,
            "enterprise": 4500000,
            "hosting1Month": 67500,
            "hosting3Month": 54000,
            "hosting6Month": 40500,
            "hosting12Month": 27000
        },
        "MKD": {
            "starter": 15800,
            "pro": 26400,
            "business": 36900,
            "enterprise": 52800,
            "hosting1Month": 790,
            "hosting3Month": 630,
            "hosting6Month": 475,
            "hosting12Month": 315
        },
        "MMK": {
            "starter": 630000,
            "pro": 1050000,
            "business": 1470000,
            "enterprise": 2100000,
            "hosting1Month": 31500,
            "hosting3Month": 25200,
            "hosting6Month": 18900,
            "hosting12Month": 12600
        },
        "MNT": {
            "starter": 1060000,
            "pro": 1775000,
            "business": 2490000,
            "enterprise": 3555000,
            "hosting1Month": 53500,
            "hosting3Month": 42700,
            "hosting6Month": 32000,
            "hosting12Month": 21300
        },
        "MOP": {
            "starter": 2400,
            "pro": 4000,
            "business": 5600,
            "enterprise": 8000,
            "hosting1Month": 120,
            "hosting3Month": 95,
            "hosting6Month": 70,
            "hosting12Month": 48
        },
        "MRU": {
            "starter": 12000,
            "pro": 20000,
            "business": 28000,
            "enterprise": 40100,
            "hosting1Month": 600,
            "hosting3Month": 480,
            "hosting6Month": 360,
            "hosting12Month": 240
        },
        "MUR": {
            "starter": 13500,
            "pro": 22500,
            "business": 31500,
            "enterprise": 45000,
            "hosting1Month": 675,
            "hosting3Month": 540,
            "hosting6Month": 405,
            "hosting12Month": 270
        },
        "MVR": {
            "starter": 4600,
            "pro": 7700,
            "business": 10800,
            "enterprise": 15400,
            "hosting1Month": 230,
            "hosting3Month": 185,
            "hosting6Month": 140,
            "hosting12Month": 92
        },
        "MWK": {
            "starter": 520000,
            "pro": 870000,
            "business": 1220000,
            "enterprise": 1740000,
            "hosting1Month": 26000,
            "hosting3Month": 20800,
            "hosting6Month": 15600,
            "hosting12Month": 10400
        },
        "MXN": {
            "starter": 5500,
            "pro": 9200,
            "business": 12900,
            "enterprise": 18400,
            "hosting1Month": 275,
            "hosting3Month": 220,
            "hosting6Month": 165,
            "hosting12Month": 110
        },
        "MYR": {
            "starter": 1300,
            "pro": 2100,
            "business": 3000,
            "enterprise": 4225,
            "hosting1Month": 60,
            "hosting3Month": 50,
            "hosting6Month": 40,
            "hosting12Month": 25
        },
        "MZN": {
            "starter": 19000,
            "pro": 31750,
            "business": 44500,
            "enterprise": 63600,
            "hosting1Month": 950,
            "hosting3Month": 760,
            "hosting6Month": 570,
            "hosting12Month": 380
        },
        "NAD": {
            "starter": 5150,
            "pro": 8600,
            "business": 12050,
            "enterprise": 17200,
            "hosting1Month": 260,
            "hosting3Month": 205,
            "hosting6Month": 155,
            "hosting12Month": 105
        },
        "NGN": {
            "starter": 438000,
            "pro": 730000,
            "business": 1020000,
            "enterprise": 1460000,
            "hosting1Month": 22000,
            "hosting3Month": 17600,
            "hosting6Month": 13200,
            "hosting12Month": 8800
        },
        "NIO": {
            "starter": 11000,
            "pro": 18400,
            "business": 25750,
            "enterprise": 36800,
            "hosting1Month": 550,
            "hosting3Month": 440,
            "hosting6Month": 330,
            "hosting12Month": 220
        },
        "NOK": {
            "starter": 3000,
            "pro": 5000,
            "business": 7000,
            "enterprise": 10000,
            "hosting1Month": 150,
            "hosting3Month": 120,
            "hosting6Month": 90,
            "hosting12Month": 60
        },
        "NPR": {
            "starter": 42000,
            "pro": 70000,
            "business": 98000,
            "enterprise": 140000,
            "hosting1Month": 2100,
            "hosting3Month": 1700,
            "hosting6Month": 1270,
            "hosting12Month": 845
        },
        "NZD": {
            "starter": 520,
            "pro": 870,
            "business": 1220,
            "enterprise": 1740,
            "hosting1Month": 26,
            "hosting3Month": 21,
            "hosting6Month": 16,
            "hosting12Month": 10
        },
        "OMR": {
            "starter": 115,
            "pro": 192,
            "business": 270,
            "enterprise": 385,
            "hosting1Month": 6,
            "hosting3Month": 5,
            "hosting6Month": 3,
            "hosting12Month": 2
        },
        "PAB": {
            "starter": 300,
            "pro": 500,
            "business": 700,
            "enterprise": 1000,
            "hosting1Month": 15,
            "hosting3Month": 12,
            "hosting6Month": 10,
            "hosting12Month": 5
        },
        "PEN": {
            "starter": 1010,
            "pro": 1690,
            "business": 2360,
            "enterprise": 3380,
            "hosting1Month": 50,
            "hosting3Month": 40,
            "hosting6Month": 30,
            "hosting12Month": 20
        },
        "PGK": {
            "starter": 1270,
            "pro": 2120,
            "business": 2970,
            "enterprise": 4250,
            "hosting1Month": 64,
            "hosting3Month": 51,
            "hosting6Month": 38,
            "hosting12Month": 25
        },
        "PHP": {
            "starter": 17500,
            "pro": 29000,
            "business": 40000,
            "enterprise": 59000,
            "hosting1Month": 875,
            "hosting3Month": 700,
            "hosting6Month": 525,
            "hosting12Month": 350
        },
        "PKR": {
            "starter": 84500,
            "pro": 141000,
            "business": 198000,
            "enterprise": 283000,
            "hosting1Month": 4250,
            "hosting3Month": 3400,
            "hosting6Month": 2550,
            "hosting12Month": 1700
        },
        "PLN": {
            "starter": 1100,
            "pro": 1850,
            "business": 2500,
            "enterprise": 3700,
            "hosting1Month": 55,
            "hosting3Month": 44,
            "hosting6Month": 33,
            "hosting12Month": 22
        },
        "PYG": {
            "starter": 2100000,
            "pro": 3530000,
            "business": 4950000,
            "enterprise": 7080000,
            "hosting1Month": 106000,
            "hosting3Month": 85000,
            "hosting6Month": 63800,
            "hosting12Month": 42500
        },
        "QAR": {
            "starter": 1090,
            "pro": 1820,
            "business": 2550,
            "enterprise": 3640,
            "hosting1Month": 55,
            "hosting3Month": 44,
            "hosting6Month": 33,
            "hosting12Month": 22
        },
        "RON": {
            "starter": 1300,
            "pro": 2175,
            "business": 3050,
            "enterprise": 4350,
            "hosting1Month": 65,
            "hosting3Month": 52,
            "hosting6Month": 39,
            "hosting12Month": 26
        },
        "RSD": {
            "starter": 30000,
            "pro": 50000,
            "business": 70000,
            "enterprise": 100000,
            "hosting1Month": 1500,
            "hosting3Month": 1200,
            "hosting6Month": 900,
            "hosting12Month": 600
        },
        "RUB": {
            "starter": 24000,
            "pro": 40000,
            "business": 56500,
            "enterprise": 80500,
            "hosting1Month": 1200,
            "hosting3Month": 970,
            "hosting6Month": 725,
            "hosting12Month": 485
        },
        "RWF": {
            "starter": 440000,
            "pro": 735000,
            "business": 1030000,
            "enterprise": 1470000,
            "hosting1Month": 22000,
            "hosting3Month": 17500,
            "hosting6Month": 13000,
            "hosting12Month": 8800
        },
        "SAR": {
            "starter": 1200,
            "pro": 1900,
            "business": 2700,
            "enterprise": 3750,
            "hosting1Month": 55,
            "hosting3Month": 45,
            "hosting6Month": 35,
            "hosting12Month": 25
        },
        "SBD": {
            "starter": 2470,
            "pro": 4120,
            "business": 5770,
            "enterprise": 8240,
            "hosting1Month": 125,
            "hosting3Month": 100,
            "hosting6Month": 75,
            "hosting12Month": 50
        },
        "SCR": {
            "starter": 4400,
            "pro": 7300,
            "business": 10250,
            "enterprise": 14650,
            "hosting1Month": 220,
            "hosting3Month": 175,
            "hosting6Month": 130,
            "hosting12Month": 88
        },
        "SDG": {
            "starter": 135000,
            "pro": 225000,
            "business": 320000,
            "enterprise": 453000,
            "hosting1Month": 6800,
            "hosting3Month": 5500,
            "hosting6Month": 4100,
            "hosting12Month": 2700
        },
        "SEK": {
            "starter": 2800,
            "pro": 4700,
            "business": 6600,
            "enterprise": 9400,
            "hosting1Month": 140,
            "hosting3Month": 110,
            "hosting6Month": 85,
            "hosting12Month": 55
        },
        "SGD": {
            "starter": 400,
            "pro": 700,
            "business": 900,
            "enterprise": 1300,
            "hosting1Month": 20,
            "hosting3Month": 15,
            "hosting6Month": 12,
            "hosting12Month": 8
        },
        "SHP": {
            "starter": 225,
            "pro": 370,
            "business": 520,
            "enterprise": 745,
            "hosting1Month": 11,
            "hosting3Month": 9,
            "hosting6Month": 7,
            "hosting12Month": 4
        },
        "SLL": {
            "starter": 7000000,
            "pro": 11650000,
            "business": 16300000,
            "enterprise": 23300000,
            "hosting1Month": 350000,
            "hosting3Month": 280000,
            "hosting6Month": 210000,
            "hosting12Month": 140000
        },
        "SOS": {
            "starter": 171000,
            "pro": 285000,
            "business": 400000,
            "enterprise": 571000,
            "hosting1Month": 8570,
            "hosting3Month": 6860,
            "hosting6Month": 5140,
            "hosting12Month": 3430
        },
        "SRD": {
            "starter": 11700,
            "pro": 19500,
            "business": 27400,
            "enterprise": 39200,
            "hosting1Month": 590,
            "hosting3Month": 470,
            "hosting6Month": 350,
            "hosting12Month": 235
        },
        "SSP": {
            "starter": 1370000,
            "pro": 2285000,
            "business": 3200000,
            "enterprise": 4575000,
            "hosting1Month": 68700,
            "hosting3Month": 55000,
            "hosting6Month": 41200,
            "hosting12Month": 27500
        },
        "STN": {
            "starter": 6300,
            "pro": 10500,
            "business": 14700,
            "enterprise": 21000,
            "hosting1Month": 315,
            "hosting3Month": 250,
            "hosting6Month": 190,
            "hosting12Month": 125
        },
        "SYP": {
            "starter": 3860000,
            "pro": 6440000,
            "business": 9020000,
            "enterprise": 12900000,
            "hosting1Month": 193500,
            "hosting3Month": 154800,
            "hosting6Month": 116100,
            "hosting12Month": 77400
        },
        "SZL": {
            "starter": 5150,
            "pro": 8600,
            "business": 12050,
            "enterprise": 17200,
            "hosting1Month": 260,
            "hosting3Month": 205,
            "hosting6Month": 155,
            "hosting12Month": 105
        },
        "THB": {
            "starter": 9750,
            "pro": 16300,
            "business": 22800,
            "enterprise": 32600,
            "hosting1Month": 490,
            "hosting3Month": 390,
            "hosting6Month": 295,
            "hosting12Month": 195
        },
        "TJS": {
            "starter": 2770,
            "pro": 4625,
            "business": 6480,
            "enterprise": 9260,
            "hosting1Month": 140,
            "hosting3Month": 110,
            "hosting6Month": 85,
            "hosting12Month": 55
        },
        "TMT": {
            "starter": 1050,
            "pro": 1750,
            "business": 2450,
            "enterprise": 3500,
            "hosting1Month": 52,
            "hosting3Month": 42,
            "hosting6Month": 32,
            "hosting12Month": 21
        },
        "TND": {
            "starter": 875,
            "pro": 1460,
            "business": 2050,
            "enterprise": 2930,
            "hosting1Month": 44,
            "hosting3Month": 35,
            "hosting6Month": 26,
            "hosting12Month": 18
        },
        "TOP": {
            "starter": 705,
            "pro": 1180,
            "business": 1650,
            "enterprise": 2360,
            "hosting1Month": 35,
            "hosting3Month": 28,
            "hosting6Month": 21,
            "hosting12Month": 14
        },
        "TRY": {
            "starter": 12500,
            "pro": 20900,
            "business": 29300,
            "enterprise": 41900,
            "hosting1Month": 630,
            "hosting3Month": 500,
            "hosting6Month": 375,
            "hosting12Month": 250
        },
        "TTD": {
            "starter": 2030,
            "pro": 3390,
            "business": 4750,
            "enterprise": 6780,
            "hosting1Month": 100,
            "hosting3Month": 80,
            "hosting6Month": 60,
            "hosting12Month": 40
        },
        "TWD": {
            "starter": 9150,
            "pro": 15250,
            "business": 21350,
            "enterprise": 30500,
            "hosting1Month": 460,
            "hosting3Month": 365,
            "hosting6Month": 275,
            "hosting12Month": 180
        },
        "TZS": {
            "starter": 735000,
            "pro": 1225000,
            "business": 1715000,
            "enterprise": 2450000,
            "hosting1Month": 36800,
            "hosting3Month": 29400,
            "hosting6Month": 22100,
            "hosting12Month": 14700
        },
        "UAH": {
            "starter": 12500,
            "pro": 20800,
            "business": 29200,
            "enterprise": 41700,
            "hosting1Month": 625,
            "hosting3Month": 500,
            "hosting6Month": 375,
            "hosting12Month": 250
        },
        "UGX": {
            "starter": 1040000,
            "pro": 1740000,
            "business": 2435000,
            "enterprise": 3480000,
            "hosting1Month": 52200,
            "hosting3Month": 41800,
            "hosting6Month": 31300,
            "hosting12Month": 20900
        },
        "UYU": {
            "starter": 12000,
            "pro": 20000,
            "business": 28000,
            "enterprise": 40000,
            "hosting1Month": 600,
            "hosting3Month": 480,
            "hosting6Month": 360,
            "hosting12Month": 240
        },
        "UZS": {
            "starter": 3620000,
            "pro": 6040000,
            "business": 8460000,
            "enterprise": 12100000,
            "hosting1Month": 181500,
            "hosting3Month": 145000,
            "hosting6Month": 109000,
            "hosting12Month": 72600
        },
        "VES": {
            "starter": 62000,
            "pro": 103500,
            "business": 145000,
            "enterprise": 207500,
            "hosting1Month": 3100,
            "hosting3Month": 2500,
            "hosting6Month": 1870,
            "hosting12Month": 1250
        },
        "VND": {
            "starter": 7850000,
            "pro": 13100000,
            "business": 18350000,
            "enterprise": 26200000,
            "hosting1Month": 393000,
            "hosting3Month": 314500,
            "hosting6Month": 236000,
            "hosting12Month": 157000
        },
        "VUV": {
            "starter": 36300,
            "pro": 60600,
            "business": 84900,
            "enterprise": 121000,
            "hosting1Month": 1820,
            "hosting3Month": 1455,
            "hosting6Month": 1090,
            "hosting12Month": 730
        },
        "WST": {
            "starter": 830,
            "pro": 1385,
            "business": 1940,
            "enterprise": 2775,
            "hosting1Month": 42,
            "hosting3Month": 33,
            "hosting6Month": 25,
            "hosting12Month": 17
        },
        "XAF": {
            "starter": 168000,
            "pro": 281000,
            "business": 394000,
            "enterprise": 562500,
            "hosting1Month": 8450,
            "hosting3Month": 6750,
            "hosting6Month": 5070,
            "hosting12Month": 3380
        },
        "XCD": {
            "starter": 805,
            "pro": 1350,
            "business": 1890,
            "enterprise": 2700,
            "hosting1Month": 40,
            "hosting3Month": 32,
            "hosting6Month": 24,
            "hosting12Month": 16
        },
        "XOF": {
            "starter": 168000,
            "pro": 281000,
            "business": 394000,
            "enterprise": 562500,
            "hosting1Month": 8450,
            "hosting3Month": 6750,
            "hosting6Month": 5070,
            "hosting12Month": 3380
        },
        "XPF": {
            "starter": 30500,
            "pro": 51000,
            "business": 71500,
            "enterprise": 102000,
            "hosting1Month": 1535,
            "hosting3Month": 1230,
            "hosting6Month": 920,
            "hosting12Month": 615
        },
        "YER": {
            "starter": 71500,
            "pro": 119000,
            "business": 167000,
            "enterprise": 239000,
            "hosting1Month": 3580,
            "hosting3Month": 2860,
            "hosting6Month": 2150,
            "hosting12Month": 1430
        },
        "ZAR": {
            "starter": 5150,
            "pro": 8600,
            "business": 12050,
            "enterprise": 17200,
            "hosting1Month": 260,
            "hosting3Month": 205,
            "hosting6Month": 155,
            "hosting12Month": 105
        },
        "ZMW": {
            "starter": 6750,
            "pro": 11300,
            "business": 15800,
            "enterprise": 22600,
            "hosting1Month": 340,
            "hosting3Month": 270,
            "hosting6Month": 205,
            "hosting12Month": 135
        },
        "ZWL": {
            "starter": 7950,
            "pro": 13275,
            "business": 18600,
            "enterprise": 26575,
            "hosting1Month": 400,
            "hosting3Month": 320,
            "hosting6Month": 240,
            "hosting12Month": 160
        }














    });

    useEffect(() => {
        const initializeCurrency = async () => {
            const userCurrency = await getUserCurrency();
            setSelectedCurrency(userCurrency);
        };
        initializeCurrency();
    }, []);

    const getPrice = (planType) => {
        // If price exists for selected currency, return it
        if (customPrices[selectedCurrency] && customPrices[selectedCurrency][planType] !== undefined) {
            return customPrices[selectedCurrency][planType];
        }
        // Otherwise fallback to USD prices
        return customPrices['USD'][planType];
    };

    const getCurrencySymbol = (selectedCurrency) => {
        switch (selectedCurrency) {
            case "AED": return "AED ";   // UAE Dirham
            case "AFN": return "؋ ";     // Afghan Afghani
            case "ALL": return "L ";     // Albanian Lek
            case "AMD": return "֏ ";     // Armenian Dram
            case "ANG": return "ANGƒ ";  // Netherlands Antillean Guilder
            case "AOA": return "Kz ";    // Angolan Kwanza
            case "ARS": return "ARS$ ";  // Argentine Peso
            case "AUD": return "A$ ";    // Australian Dollar
            case "AWG": return "AWGƒ ";  // Aruban Florin
            case "AZN": return "₼ ";     // Azerbaijani Manat
            case "BAM": return "КМ ";    // Bosnia Convertible Mark
            case "BBD": return "Bds$ ";  // Barbadian Dollar
            case "BDT": return "৳ ";     // Bangladeshi Taka
            case "BGN": return "лв ";    // Bulgarian Lev
            case "BHD": return "د.ب ";   // Bahraini Dinar
            case "BIF": return "BIF Fr "; // Burundian Franc
            case "BMD": return "BD$ ";   // Bermudian Dollar
            case "BND": return "BN$ ";   // Brunei Dollar
            case "BOB": return "Bs. ";   // Bolivian Boliviano
            case "BRL": return "R$ ";    // Brazilian Real
            case "BSD": return "BS$ ";   // Bahamian Dollar
            case "BTN": return "Nu. ";   // Bhutanese Ngultrum
            case "BWP": return "P ";     // Botswanan Pula
            case "BYN": return "Br ";    // Belarusian Ruble
            case "BZD": return "BZ$ ";   // Belize Dollar
            case "CAD": return "CAD$ ";    // Canadian Dollar
            case "CDF": return "CDF ";   // Congolese Franc
            case "CHF": return "CHF ";   // Swiss Franc
            case "CLP": return "CLP$ ";  // Chilean Peso
            case "CNY": return "¥ ";     // Chinese Yuan
            case "COP": return "COP$ ";  // Colombian Peso
            case "CRC": return "₡ ";     // Costa Rican Colón
            case "CUP": return "CUP$ ";  // Cuban Peso
            case "CVE": return "Esc ";   // Cape Verdean Escudo
            case "CZK": return "Kč ";    // Czech Koruna
            case "DJF": return "DJF Fr "; // Djiboutian Franc
            case "DKK": return "kr ";    // Danish Krone
            case "DOP": return "RD$ ";   // Dominican Peso
            case "DZD": return "د.ج ";   // Algerian Dinar
            case "EGP": return "E£ ";    // Egyptian Pound
            case "ERN": return "Nfk ";   // Eritrean Nakfa
            case "ETB": return "Br ";    // Ethiopian Birr
            case "EUR": return "€ ";     // Euro
            case "FJD": return "FJ$ ";   // Fijian Dollar
            case "FKP": return "FK£ ";   // Falkland Islands Pound
            case "GBP": return "£ ";     // Pound Sterling (main)
            case "GEL": return "₾ ";     // Georgian Lari
            case "GHS": return "₵ ";     // Ghanaian Cedi
            case "GIP": return "GI£ ";   // Gibraltar Pound
            case "GMD": return "D ";     // Gambian Dalasi
            case "GNF": return "GNF Fr "; // Guinean Franc
            case "GTQ": return "Q ";     // Guatemalan Quetzal
            case "GYD": return "GY$ ";   // Guyanese Dollar
            case "HKD": return "HK$ ";   // Hong Kong Dollar
            case "HNL": return "HNL ";   // Honduran Lempira
            case "HTG": return "G ";     // Haitian Gourde
            case "HUF": return "Ft ";    // Hungarian Forint
            case "IDR": return "Rp ";    // Indonesian Rupiah
            case "ILS": return "₪ ";     // Israeli New Shekel
            case "INR": return "₹ ";     // Indian Rupee
            case "IQD": return "ع.د ";   // Iraqi Dinar
            case "IRR": return "﷼ ";     // Iranian Rial
            case "ISK": return "Íkr ";   // Icelandic Króna
            case "JMD": return "J$ ";    // Jamaican Dollar
            case "JOD": return "د.ا ";   // Jordanian Dinar
            case "JPY": return "¥ ";     // Japanese Yen
            case "KES": return "KSh ";   // Kenyan Shilling
            case "KGS": return "с ";     // Kyrgyzstani Som
            case "KHR": return "៛ ";     // Cambodian Riel
            case "KMF": return "KMF Fr "; // Comorian Franc
            case "KPW": return "₩KP ";   // North Korean Won
            case "KRW": return "₩ ";     // South Korean Won (main)
            case "KWD": return "د.ك ";   // Kuwaiti Dinar
            case "KYD": return "KY$ ";   // Cayman Islands Dollar
            case "KZT": return "₸ ";     // Kazakhstani Tenge
            case "LAK": return "₭ ";     // Lao Kip
            case "LBP": return "ل.ل ";   // Lebanese Pound
            case "LKR": return "Rs ";    // Sri Lankan Rupee
            case "LRD": return "L$ ";    // Liberian Dollar
            case "LSL": return "LSL ";   // Lesotho Loti
            case "LYD": return "ل.د ";   // Libyan Dinar
            case "MAD": return "د.م. ";  // Moroccan Dirham
            case "MDL": return "MDL ";   // Moldovan Leu
            case "MGA": return "Ar ";    // Malagasy Ariary
            case "MKD": return "ден ";   // Macedonian Denar
            case "MMK": return "Ks ";    // Myanmar Kyat
            case "MNT": return "₮ ";     // Mongolian Tögrög
            case "MOP": return "MOP ";   // Macanese Pataca
            case "MRU": return "UM ";    // Mauritanian Ouguiya
            case "MUR": return "MUR₨ ";  // Mauritian Rupee
            case "MVR": return "ރ ";     // Maldivian Rufiyaa
            case "MWK": return "MK ";    // Malawian Kwacha
            case "MXN": return "Mex$ ";  // Mexican Peso
            case "MYR": return "RM ";    // Malaysian Ringgit
            case "MZN": return "MT ";    // Mozambican Metical
            case "NAD": return "N$ ";    // Namibian Dollar
            case "NGN": return "₦ ";     // Nigerian Naira
            case "NIO": return "C$ ";    // Nicaraguan Córdoba
            case "NOK": return "Nkr ";   // Norwegian Krone
            case "NPR": return "N₨ ";    // Nepalese Rupee
            case "NZD": return "NZ$ ";   // New Zealand Dollar
            case "OMR": return "ر.ع. ";  // Omani Rial
            case "PAB": return "B/. ";   // Panamanian Balboa
            case "PEN": return "S/ ";    // Peruvian Sol
            case "PGK": return "K ";     // Papua New Guinean Kina
            case "PHP": return "₱ ";     // Philippine Peso
            case "PKR": return "₨ ";     // Pakistani Rupee
            case "PLN": return "zł ";    // Polish Złoty
            case "PYG": return "₲ ";     // Paraguayan Guaraní
            case "QAR": return "ر.ق ";   // Qatari Riyal
            case "RON": return "lei ";   // Romanian Leu
            case "RSD": return "дин ";   // Serbian Dinar
            case "RUB": return "₽ ";     // Russian Ruble
            case "RWF": return "RWF Fr "; // Rwandan Franc
            case "SAR": return "ر.س ";   // Saudi Riyal
            case "SBD": return "SI$ ";   // Solomon Islands Dollar
            case "SCR": return "SCR₨ ";  // Seychellois Rupee
            case "SDG": return "ج.س. ";  // Sudanese Pound
            case "SEK": return "Skr ";   // Swedish Krona
            case "SGD": return "S$ ";    // Singapore Dollar
            case "SHP": return "SH£ ";   // Saint Helena Pound
            case "SLL": return "Le ";    // Sierra Leonean Leone
            case "SOS": return "SoSh ";  // Somali Shilling
            case "SRD": return "SRD$ ";  // Surinamese Dollar
            case "SSP": return "SS£ ";   // South Sudanese Pound
            case "STN": return "Db ";    // São Tomé Dobra
            case "SYP": return "ل.س ";   // Syrian Pound
            case "SZL": return "SZL ";   // Swazi Lilangeni
            case "THB": return "฿ ";     // Thai Baht
            case "TJS": return "ЅМ ";    // Tajikistani Somoni
            case "TMT": return "m ";     // Turkmenistani Manat
            case "TND": return "د.ت ";   // Tunisian Dinar
            case "TOP": return "T$ ";    // Tongan Paʻanga
            case "TRY": return "₺ ";     // Turkish Lira
            case "TTD": return "TT$ ";   // Trinidad Dollar
            case "TWD": return "NT$ ";   // New Taiwan Dollar
            case "TZS": return "TSh ";   // Tanzanian Shilling
            case "UAH": return "₴ ";     // Ukrainian Hryvnia
            case "UGX": return "USh ";   // Ugandan Shilling
            case "USD": return "$ ";     // US Dollar (main $)
            case "UYU": return "UY$ ";   // Uruguayan Peso
            case "UZS": return "so'm ";  // Uzbekistani Som
            case "VES": return "Bs.S ";  // Venezuelan Bolívar
            case "VND": return "₫ ";     // Vietnamese Dong
            case "VUV": return "Vt ";    // Vanuatu Vatu
            case "WST": return "WS$ ";   // Samoan Tala
            case "XAF": return "FCFA ";  // CFA Franc BEAC
            case "XCD": return "EC$ ";   // East Caribbean Dollar
            case "XOF": return "CFA ";   // CFA Franc BCEAO
            case "XPF": return "CFP ";   // CFP Franc
            case "YER": return "﷼ ";     // Yemeni Rial
            case "ZAR": return "R ";     // South African Rand
            case "ZMW": return "ZK ";    // Zambian Kwacha
            case "ZWL": return "ZWL$ ";  // Zimbabwe Dollar
            default: return "$ ";        // Default fallback
        }
    };



    return (
        <CurrencyContext.Provider value={{
            selectedCurrency,
            setSelectedCurrency,
            customPrices,
            setCustomPrices,
            getPrice,
            getCurrencySymbol
        }}>
            {children}
        </CurrencyContext.Provider>
    );
};

export const useCurrency = () => {
    const context = useContext(CurrencyContext);
    if (!context) {
        throw new Error('useCurrency must be used within a CurrencyProvider');
    }
    return context;
}; 
